import api from "../../../../services/api";

// ========================================
// Get All Favorites
// ========================================

export const getFavorites = async () => {

    const { data } = await api.get(
        "/favorites"
    );

    return data;

};

// ========================================
// Toggle Favorite
// ========================================

export const toggleFavorite = async (foodId) => {

    const { data } = await api.post(
        `/favorites/${foodId}`
    );

    return data;

};

// ========================================
// Check Favorite
// ========================================

export const checkFavorite = async (foodId) => {

    const { data } = await api.get(
        `/favorites/check/${foodId}`
    );

    return data;

};